import { RouteObject } from "react-router-dom";
import MainRoot from "../components/root/MainRoot";
import NotFound from "../pages/not-found/NotFound";
import Home from "../pages/ui/home/Home";
import Login from "../pages/auth/login/Login";
import Products from "../pages/ui/proucts/Products";
import ProductDetail from "../pages/ui/proucts/detail/ProductDetail";
import PrivacyPolicy from "../pages/ui/privacy-policy/PrivacyPolicy";
import Stores from "../pages/ui/stores/Stores";
import Contact from "../pages/ui/contact/Contact";
import StoreProducts from "../pages/ui/stores/products/StoreProducts";
import Register from "../pages/auth/register/Register";
import ForgetPassword from "../pages/auth/forget-password/ForgetPassword";
import Otp from "../pages/auth/otp/Otp";
import ConfirmPassword from "../pages/auth/confirm-password/ConfirmPassword";
import UserInfo from "../pages/auth/user-info/UserInfo";
import Notifications from "../pages/auth/notifications/Notifications";
import Addresses from "../pages/auth/addresses/Addresses";
import Orders from "../pages/Orders/Orders";
import GoogleCallback from "../pages/auth/google-callback/GoogleCallback";
import Wishlist from "../pages/ui/wishlist/Wishlist";
import Basket from "../pages/ui/basket/Basket";
import Success from "../pages/ui/payment-response/Success";
import Error from "../pages/ui/payment-response/Error";
import MyLocations from "../pages/ui/my-locations/MyLocations";
import PartnerShip from "../pages/ui/partner-ship/PartnerShip";
import BecomeSeller from "../pages/ui/become-seller/BecomeSeller";
import About from "../pages/ui/about/About";
import CompleteOrder from "../pages/ui/complere-order/CompleteOrder";
import OrderDetail from "../pages/ui/my-orders/detail/OrderDetail";
import ReturnDelivery from "../pages/ui/return-delivery/ReturnDelivery";
import SearchResults from "../pages/ui/search/SearchResults";

const ROUTES: RouteObject[] = [
  {
    path: "/payment/success",
    element: <Success />,
  },
  {
    path: "/payment/error",
    element: <Error />,
  },
  {
    path: "/auth/google/callback",
    element: <GoogleCallback />,
  },
  {
    path: "/",
    element: <MainRoot />,
    children: [
      {
        index: true,
        element: <Home />,
      },
    ],
  },
  {
    path: "/:lang",
    element: <MainRoot />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "auth/login",
        element: <Login />,
      },
      {
        path: "auth/register",
        element: <Register />,
      },
      {
        path: "auth/otp",
        element: <Otp />,
      },
      {
        path: "auth/info",
        element: <UserInfo />,
      },
      {
        path: "auth/notifications",
        element: <Notifications />,
      },
      {
        path: "auth/addresses",
        element: <Addresses />,
      },
      {
        path: "auth/forget-password",
        element: <ForgetPassword />,
      },
      {
        path: "auth/confrim-forget-password",
        element: <ConfirmPassword />,
      },
      {
        path: "auth/google/callback",
        element: <GoogleCallback />,
      },
      {
        path: "products/:id",
        element: <Products />,
      },
      {
        path: "product/:id",
        element: <ProductDetail />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "stores",
        element: <Stores />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "store-products/:id",
        element: <StoreProducts />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "wishlist",
        element: <Wishlist />,
      },
      {
        path: "locations",
        element: <MyLocations />,
      },
      {
        path: "basket",
        element: <Basket />,
      },
      {
        path: "partnership",
        element: <PartnerShip />,
      },
      {
        path: "becomeseller",
        element: <BecomeSeller />,
      },
      {
        path: "complete-order",
        element: <CompleteOrder />,
      },
      {
        path: "orders",
        element: <Orders />,
      },
      {
        path: "orders/:id",
        element: <OrderDetail />,
      },
      {
        path: "return-delivery",
        element: <ReturnDelivery />,
      },
      {
        path: "search",
        element: <SearchResults />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default ROUTES;
